<template>
  <div>
    <modal
      :show.sync="editTopic"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Edit Topic
      </h6>
      <div>
        <div class="mb-6">
          <p class="font-semibold text-md pb-1">Topic Name</p>
          <base-input
            placeholder="Enter Topic Name"
            class="cust-mb0"
            v-model="topic_info.name"
          ></base-input>
        </div>
        <div class="mb-6">
          <p class="font-semibold text-md pb-1">Upload Files</p>
          <div class="flex gap-4">
            <vx-card
              class="shadow-none bg-f4f5f6 mx-1 hover:bg-white cursor-pointer py-3 rounded-md"
            >
              <!-- <div class="flex justify-center">
                <img :src="item.img" class="w-2/5 " />
              </div>
              <p class="font-semibold text-center text-sm pt-2">
                {{ item.title }}
              </p> -->
              <div class="">
                <div @click="vidInput(docVideo)" id="vidDisable">
                  <div class="flex justify-center">
                    <img src="../img/video.png" class="w-2/5" />
                  </div>

                  <p class="font-semibold text-center text-sm pt-2">
                    Video
                    <!-- previous video accept: accept=".mkv,.avi,video/*" -->
                    <input
                      type="file"
                      style="display: none"
                      ref="vidfile"
                      id="videoInput"
                      accept=".mp4,.mkv,.avi,video/*"
                      class="videoInput"
                      @change="onFileChange"
                    />
                  </p>
                </div>

                <!-- <div @click="embInput()">
                  <div class="flex justify-center">
                    <img src="../img/embed.png" class="w-2/5" />
                  </div>
                  <p class="font-semibold text-center text-sm pt-2">
                    Embedded

                    <input
                      type="file"
                      style="display: none"
                      id="embedInput"
                      @change="onFileChange"
                    />
                  </p>
                </div> -->
                <!-- <div @click="assesInput()">
                  <div class="flex justify-center">
                    <img src="../img/assessment.png" class="w-2/5" />
                  </div>
                  <p class="font-semibold text-center text-sm pt-2">
                    Assessment

                    <input
                      type="file"
                      style="display: none"
                      id="assesInput"
                      @change="onFileChange"
                    />
                  </p>
                </div> -->
                <!-- <div @click="liveInput()">
                  <div class="flex justify-center">
                    <img src="../img/live.png" class="w-2/5" />
                  </div>
                  <p class="font-semibold text-center text-sm pt-2">
                    Live Event

                    <input
                      type="file"
                      style="display: none"
                      id="liveInput"
                      @change="onFileChange"
                    />
                  </p>
                </div> -->
              </div>
            </vx-card>
            <vx-card
              class="shadow-none bg-f4f5f6 mx-1 hover:bg-white cursor-pointer py-3 rounded-md"
            >
              <div @click="docsInput(docPdf)" id="docDisable">
                <div class="flex justify-center">
                  <img src="../img/doc.png" class="w-2/5" />
                </div>
                <p class="font-semibold text-center text-sm pt-2">
                  Documents
                  <!-- previous doc accept: accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" -->
                  <input
                    type="file"
                    style="display: none"
                    ref="docfile"
                    accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    id="docInput"
                    @change="onFileChange"
                  />
                </p>
                <p class="text-xs text-center text-muted mt-1 px-2">
                  PDF, DOC, DOCX allowed
                </p></div
            ></vx-card>
          </div>
        </div>
        <!-- <div class="mb-6">
        <div class="progress-wrapper">
          <div class="progress rounded-lg mb-0">
            <div
              class="progress-bar bg-default"
              role="progressbar"
              aria-valuenow="60"
              aria-valuemin="0"
              aria-valuemax="100"
              style="width: 60%;"
            ></div>
          </div>
          <div class="progress-info pt-1 mb-0">
            <div class="progress-label">
              <span class="badge badge-pill badge-default">In Progress</span>
            </div>
            <div class="progress-percentage">
              <span class="">60%</span>
            </div>
          </div>
        </div>
      </div> -->
        <div class="flex justify-center" v-if="files && files.length !== 0">
          <div class="flex px-5 py-1 bg-f4f5f6 rounded-full">
            <p
              class="text-xs font-semibold"
              v-for="(file, index) in files"
              :key="index"
            >
              {{ file.name }}
            </p>
            <feather-icon
              icon="XIcon"
              class="font-semibold cursor-pointer icon18px ml-5 my-auto"
              @click="removeImage()"
            ></feather-icon>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" @click="edit_topic()"
          >SAVE CHANGES</base-button
        >
        <base-button @click="closeModal" type="secondary" class="ml-auto"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import {
  isAllowedDocumentFile,
  isAllowedVideoFile,
} from "@/utils/mediaUrl";

export default {
  props: {
    editTopic: Boolean,
    editPopup: Function,
    topicInfo: Object,
  },

  data() {
    return {
      // chapters: [
      //   {
      //     img: require("../img/video.png"),
      //     title: "Video"
      //   },
      //   {
      //     img: require("../img/doc.png"),
      //     title: "Document"
      //   },
      //   {
      //     img: require("../img/embed.png"),
      //     title: "Embedded"
      //   },
      //   {
      //     img: require("../img/assessment.png"),
      //     title: "Assessment"
      //   },
      //   {
      //     img: require("../img/live.png"),
      //     title: "Live Event"
      //   }
      // ],
      docType: "",
      docPath: "",
      editData: {},
      files: [],
      fileName: "",
      docVideo: "video",
      docPdf: "pdf",
      vidDuration: "0",
      topic_info: {},
      maxSize: 20 * 1024 * 1024,
    };
  },
  watch: {
    topicInfo(newVal) {
      this.topic_info = { ...newVal };
    },
  },
  methods: {
    vidInput(data) {
      document.getElementById("vidDisable").style.pointerEvents = "auto";
      document.getElementById("docDisable").style.pointerEvents = "none";
      let input = document.getElementById("videoInput").click();
      // console.log(data);
    },

    docsInput(data) {
      document.getElementById("vidDisable").style.pointerEvents = "none";
      document.getElementById("docDisable").style.pointerEvents = "auto";
      document.getElementById("docInput").click();
      // console.log(data);
    },

    onFileChange(e) {
      this.files = e.target.files;
      let self = this;
      if (this.$refs.vidfile.files[0]) {
        const videoFile = this.$refs.vidfile.files[0];
        // Previous: no video type validation, only size check
        if (!isAllowedVideoFile(videoFile)) {
          this.$swal.fire({
            title: "Error",
            text: "Only MP4, MKV, and AVI video files are allowed",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.removeImage();
          return;
        }
        if (videoFile.size > this.maxSize) {
          this.$swal.fire({
            title: "Error",
            text: "File size exceeds 20MB!",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.removeImage();
        }
        let vid = document.createElement("video");
        let fileUrl = URL.createObjectURL(this.$refs.vidfile.files[0]);
        vid.src = fileUrl;

        vid.ondurationchange = function () {
          let duration = Number(this.duration).toFixed(0);
          self.vidDuration = duration;
        };

        this.fileName = this.$refs.vidfile.files[0].name;
      } else if (this.$refs.docfile.files[0]) {
        const docFile = this.$refs.docfile.files[0];
        // Previous: no document type validation, only size check
        if (!isAllowedDocumentFile(docFile)) {
          this.$swal.fire({
            title: "Error",
            text: "Only PDF, DOC, and DOCX files are allowed",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.removeImage();
          return;
        }
        if (docFile.size > this.maxSize) {
          this.$swal.fire({
            title: "Error",
            text: "File size exceeds 20MB!",
            icon: "warning",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.removeImage();
        }
        this.fileName = this.$refs.docfile.files[0].name;
      }
      // console.log(this.fileName);
    },
    removeImage() {
      this.files = "";
      document.getElementById("videoInput").value = "";
      document.getElementById("docInput").value = "";
      document.getElementById("vidDisable").style.pointerEvents = "auto";
      document.getElementById("docDisable").style.pointerEvents = "auto";
    },

    async edit_topic() {
      if (this.topicInfo.name.length != 0) {
        let payload = new FormData();
        payload.append("name", this.topic_info.name);
        payload.append("_id", this.topic_info._id);
        // console.log(this.topicInfo.docPath);
        if (this.fileName == "") {
          payload.append("docType", this.docType);
          payload.append("docPath", this.docPath);
        } else {
          const filename = this.fileName;
          const ext = filename.split(".").pop();
          if (ext == "mp4" || ext == "mkv" || ext == "avi") {
            payload.append("docType", "video");
            payload.append("duration", this.vidDuration);

            payload.append("docPath", this.$refs.vidfile.files[0]);
          } else if (ext == "doc" || ext == "docx" || ext == "pdf") {
            payload.append("docType", ext.toLowerCase());
            payload.append("duration", "");

            payload.append("docPath", this.$refs.docfile.files[0]);
          }
        }

        // for (var pair of payload.entries()) {
        //   console.log(pair[0] + " : " + pair[1]);
        // }
        let loader = this.$loading();

        const data = await this.$store.dispatch("eLearning/editTopic", payload);

        // console.log(data);
        if (data.code == 200) {
          loader.close();
          this.$swal.fire({
            title: "Edited",

            text: "Topic has been edited Successfully!",

            icon: "success",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.closeModal();
        }
      }
    },
    closeModal() {
      this.$emit("close-editTopic");
    },
  },
  // computed : {
  //   name : {
  //     get(){
  //       return this.topicInfo.name;
  //     },
  //     set(newValue){
  //       let name = newValue.split(" ");
  //       this.topicInfo.name = name[name.length - 1];
  //     }
  //   }
  // }
};
</script>
